import React, { useState, useEffect } from "react";
import { saveAs } from "file-saver";
import { Modal, Spinner } from "react-bootstrap";
import { CloseIconRound } from "../../../assets/Logos/Icons";
import PdfPreview from "../../Util/PdfPreview";
import DownloadComponent from "../../Util/DownloadComponent";
import DICOMViewer from "../../Util/DICOMViewer";
import DWVViewer from "../../Util/DWVViewer";
import HTMLRenderer from "react-html-renderer";

import "./fileviewmodal.scss";

function FileViewModal({ isShowModal, onClose, file }) {
  const [isLoading, setIsLoading] = useState(true);

  const supportfiles = ["JPG", "jpg", "JPEG", "jpeg", "PNG", "png"];

  useEffect(() => {
    if (file != null && file !== undefined) {
      if (!supportfiles.includes(file?.filetypes)) {
        file?.type != "uploads"
          ? saveAs(file?.filecontent, file?.filename)
          : saveAs(file?.filecontent, file?.item?.title);

        onClose();
        console.log("hi2");
      } else {
        setIsLoading(false);
      }
    } else {
      console.log("hi");
    }
  }, []);

  console.log("File object:", file);
  console.log("File URL:", file?.fileurl);

  const handleImageLoad = () => {
    setIsLoading(false);
  };

  const handleImageError = () => {
    console.error("Error loading image");
    setIsLoading(false); // Set loading to false in case of error
  };

  console.log("file", file);
  
  return (
    <div>
      <Modal
        style={{ overflow: "hidden", zIndex: 20000 }}
        show={isShowModal}
        onHide={() => onClose()}
        backdrop="static"
      >
        <Modal.Header className="file-view-modal-header">
          <div className="file-view-modal-header_title">
            <div> File preview</div>
            <div className="file-view-modal-header_filename">
              {file?.type != "uploads" ? file?.filename : file?.item?.title}
            </div>
          </div>
          <div className="file-view-modal-header_close" onClick={onClose}>
            <CloseIconRound />
          </div>
        </Modal.Header>

        <Modal.Body>
          <div className="file-preview-modal-body">
            {isLoading ? <Spinner animation="border" role="status" /> : null}
            {supportfiles.includes(file?.filetypes) ? (
             <img  
             onLoad={handleImageLoad}  
             onError={handleImageError}  
             alt=""  
             src={file?.fileurl || file?.filecontent} // Use fileurl if available, otherwise use filecontent  
             style={{ maxWidth: "470px", maxHeight: "500px", width: "100%" }}  
           />
           
            ) : (
              //: file?.filetypes === "DCM" ?
              //  window.open("https://uat.c2mdr.com/ganga/dicom.html?url="+file?.fileurl,'_blank')
              //   // <DWVViewer
              //   //   fileUrl={file?.fileurl}
              //   //   fileName={file?.filename}
              //   //   onClose={onClose}
              //   // />
              <DownloadComponent
                fileUrl={file?.fileurl}
                fileName={file?.filename}
                onClose={onClose}
              />
            )}
            {/* <img
                src={file?.fileurl}
                alt="Image"
                onLoad={handleImageLoad}
                //style={{ display: "none" }} // Optional: Hide the image element
              /> */}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default FileViewModal;
